import React, { useState } from 'react';
import type { FormEvent, MouseEvent } from 'react';
import { useNavigate } from 'react-router';
import { Layout } from "../../components/OnboardingLayout";
import { BoxWithIcon } from '../../components/BoxWithIcon';
import { AttributeContainer, Attribute } from '../../components/Attributes';
import LoadingButton from '@mui/lab/LoadingButton'; 
import HandCoin from '../../images/hand_coin.png';
import Shop from '../../images/shop.png';

const Behavior = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [ selected, setSelected ] = useState('default')

    const navigate = useNavigate();

    const submit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsLoading(true);
        const request = await fetch(`${process.env.REACT_APP_API_URL}/api/shop/`, {
            credentials: 'include',
            method: 'PUT',
            body: JSON.stringify({
                behavior: selected
            })
        });
        const response = await request.json();
        if(response.shop) {
            navigate('/onboarding/payment');
        }
    }

    const handleSelection = (e: MouseEvent<HTMLDivElement>, item: string) => {
        setSelected(item)
    }

    return (
        <Layout
            stage={2}
            title="Choose who’s covering the cost of offsets"
            subTitle="Determine whether you or your customers pay for the cost of carbon."
            contentTitle="Behaviour"
        >
            <form onSubmit={submit}>
                <label>Customer pays</label>
                <BoxWithIcon onClick={handleSelection} text='Your customers' icon={HandCoin} active={selected == 'default'} item='default' />
                <AttributeContainer active={selected == 'default'}>
                    <Attribute text='Free to you' />
                    <Attribute text='$0.25 + the cost of carbon' />
                </AttributeContainer>
                <label>Shop pays</label>
                <BoxWithIcon onClick={handleSelection} text='Your Store' icon={Shop} active={selected == 'merchant'} item='merchant' />
                <AttributeContainer active={selected == 'merchant'}>
                    <Attribute text='Cover the cost of offsetting all of your shipping emissions' />
                    <Attribute text='$0.15 or less + the cost of carbon' />
                </AttributeContainer>
                <LoadingButton loading={isLoading} type="submit" variant='contained'>Save & Continue</LoadingButton>
            </form>
        </Layout>
    )
}

export default Behavior;